import { shallowEqual } from 'react-redux'
import { ChrofyCustomSelect } from '../../../common/ChrofyCustomSelect'
import { useSecuritiesReportDispatch, useSecuritiesReportSelector } from '../extra/store'
import _get from 'lodash/get'
import { ErrorComponent } from './ErrorComponent'

const calculationTargets = [
  {
    value: '期末時点',
    label: '期末時点'
  },
  {
    value: '年間平均',
    label: '年間平均'
  },
  {
    value: '通期実労働基準',
    label: '通期実労働基準'
  }
]

const calculationMethods = [
  {
    value: 'ヘッドカウント',
    label: 'ヘッドカウント'
  },

  {
    value: 'FTE（雇用区分概算）',
    label: 'FTE（雇用区分概算）'
  },
  {
    value: 'FTE（実労働時間換算）',
    label: 'FTE（実労働時間換算）'
  }
]

const calculationMethodOptions = {
  期末時点: [calculationMethods[0], calculationMethods[1]],
  年間平均: calculationMethods,
  通期実労働基準: [calculationMethods.at(-1)]
}

const EmployeeCountCalculationMethod = () => {
  const employeeCountUrl = '/master/dashboard/employeeCountInfo'

  const { tempEmpCalcBase = '', tempEmpCalcMethod = '' } = useSecuritiesReportSelector((s) =>
    _get(s, ['pageState', s.selectedFiscalYear, 'companyConfig'], {})
  )

  const clientErrors = useSecuritiesReportSelector((s) => s.errors.client)

  const dispatch = useSecuritiesReportDispatch()

  /**
   * @function changeCalculationTarget 計算対象 設定
   * @param {{import('react').ChangeEvent<HTMLSelectElement>}} e
   */
  const changeCalculationTarget = (e) => {
    const value = e.target.value

    dispatch('SET_COMPANY_CONFIG', {
      path: 'tempEmpCalcBase',
      value
    })

    dispatch('SET_COMPANY_CONFIG', {
      path: 'tempEmpCalcMethod',
      value: ''
    })
  }

  /**
   * @function changeCalculationMethod 計算方法を設定
   * @param {import('react').ChangeEvent<HTMLSelectElement>} e
   */
  const changeCalculationMethod = (e) => {
    const value = e.target.value

    dispatch('SET_COMPANY_CONFIG', {
      path: 'tempEmpCalcMethod',
      value
    })
  }

  return (
    <>
      <h2 className="text-body-2-bold grow ">■人数計算方式</h2>

      <p className="mt-5">
        従業員数のカウント方法を設定してください。有報従業員区分（従業員、臨時従業員）ごとにカウント方法が設定できます
      </p>

      <p>
        ここでの設定内容はグループ全体で共通となり、CHROFYを利用している会社の従業員数は、ここで指定した設定に基づいて算出されます。
      </p>
      <p>
        人数カウントの詳細条件は、
        <a className="text-blue-500" href={employeeCountUrl} target="_blank">
          人数カウント設定画面
        </a>
        で設定してください。
      </p>

      <div className="setting-table max-w-[90%] mt-5">
        <table className="base-table table-fixed w-full">
          <thead>
            <tr>
              <th colSpan={2}>従業員</th>
              <th colSpan={2}>臨時従業員</th>
            </tr>
            <tr>
              <th>計算対象</th>
              <th>計算方法</th>
              <th>
                計算対象 <span className="red--text ">＊</span>
              </th>
              <th>
                計算方法 <span className="red--text ">＊</span>
              </th>
            </tr>
          </thead>
          <tbody className="text-base">
            <tr>
              <td>期末時点</td>
              <td>ヘッドカウント</td>
              <td>
                <ChrofyCustomSelect
                  hasNoSelect
                  name="tempEmpCalcBase"
                  onChange={changeCalculationTarget}
                  options={calculationTargets}
                  value={tempEmpCalcBase}
                  data-testid="tempEmpCalcBase"
                />
              </td>
              <td>
                <ChrofyCustomSelect
                  hasNoSelect
                  name="tempEmpCalcMethod"
                  onChange={changeCalculationMethod}
                  options={calculationMethodOptions?.[tempEmpCalcBase] ?? []}
                  value={tempEmpCalcMethod}
                  data-testid="tempEmpCalcMethod"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-3">
        <ErrorComponent errors={clientErrors} errorKeys={['tempEmpCalcBase', 'tempEmpCalcMethod']} />
      </div>
    </>
  )
}
export default EmployeeCountCalculationMethod
